var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconContactVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.46667C8.08798 2.46667 4.91667 5.74991 4.91667 9.8V11.2667H6.33333C7.11574 11.2667 7.75 11.9233 7.75 12.7333V17.1333C7.75 17.9434 7.11574 18.6 6.33333 18.6H4.91667C4.13426 18.6 3.5 17.9434 3.5 17.1333V9.8C3.5 4.93989 7.30558 1 12 1C16.6944 1 20.5 4.93989 20.5 9.8V18.6C20.5 20.625 18.9143 22.2667 16.9583 22.2667H13.9355C13.6905 22.7051 13.2327 23 12.7083 23H11.2917C10.5093 23 9.875 22.3434 9.875 21.5333C9.875 20.7233 10.5093 20.0667 11.2917 20.0667H12.7083C13.2327 20.0667 13.6905 20.3616 13.9355 20.8H16.9583C18.1319 20.8 19.0833 19.815 19.0833 18.6H17.6667C16.8843 18.6 16.25 17.9434 16.25 17.1333V12.7333C16.25 11.9233 16.8843 11.2667 17.6667 11.2667H19.0833V9.8C19.0833 5.74991 15.912 2.46667 12 2.46667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconContactVoice);
export default __webpack_public_path__ + "static/media/button-icon-contact-voice.addb42df7a909aeda020c9f77bb6668a.svg";
export { ForwardRef as ReactComponent };